<template>
  <v-card id="account-setting-card">
    <!-- tabs -->
    <v-tabs v-model="tab" show-arrows>
      <v-tab v-for="tab in tabs" :key="tab.icon">
        <v-icon size="20" class="me-3">
          {{ tab.icon }}
        </v-icon>
        <span>{{ tab.title }}</span>
      </v-tab>
    </v-tabs>

    <!-- tabs item -->
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <empleado-configuracion-empelado
          ref="EmpleadoConfiguracionEmpeladoRef"
          @CambiarTab="CambiarTab"
          @GuardarDatos="GuardarDatos"
          @ResetFormulario="ResetFormulario"
          :EmpleadoData="configuracionEmpleadoData"
        >
        </empleado-configuracion-empelado>
      </v-tab-item>

      <v-tab-item>
        <empleado-configuracion-seguridad
          @ResetFormulario="ResetFormulario"
          ref="EmpleadoConfiguracionSeguridadRef"
          @GuardarDatos="GuardarDatos"
          :EmpleadoData="configuracionEmpleadoData"
        >
        </empleado-configuracion-seguridad>
      </v-tab-item>
    </v-tabs-items>
      </v-card>
</template>

<script>
import SeguridadService from '@/api/servicios/SeguridadService'
import { mdiAccountOutline, mdiLockOpenOutline, mdiInformationOutline } from '@mdi/js'
import { ref, context } from '@vue/composition-api'

// demos
import EmpleadoConfiguracionEmpelado from './EmpleadoConfiguracionEmpelado.vue'
import EmpleadoConfiguracionSeguridad from './EmpleadoConfiguracionSeguridad.vue'
 import goTo from 'vuetify/lib/services/goto'
 import store from '@/store'

export default {
  components: {
    EmpleadoConfiguracionEmpelado,
    EmpleadoConfiguracionSeguridad,
    
  },
  setup(props, context) {
     
    const tab = ref('')
    const EmpleadoConfiguracionEmpeladoRef = ref(null)
    const EmpleadoConfiguracionSeguridadRef = ref(null)

    // tabs
    const tabs = [
      { title: 'Empleado', icon: mdiAccountOutline },
      { title: 'Seguridad', icon: mdiLockOpenOutline },
    ]

    const EnviarDatos = item => {
      console.log(item)
      configuracionEmpleadoData.value = item
    }

    const CambiarTab = dato => {
      console.log(tab.value)
      tab.value = dato
      console.log(tab.value)
    }

    const GuardarDatos = async (datos, modulo) => {
      if (modulo == 2) {
        if (EmpleadoConfiguracionEmpeladoRef.value.validarForm()) {
          console.log({
            empleado: {
              ...EmpleadoConfiguracionEmpeladoRef.value.datos,
              usuario: { ...EmpleadoConfiguracionSeguridadRef.value.datos.usuario },
            },
          })
          console.log(EmpleadoConfiguracionSeguridadRef.value.datos.usuario)
          let imagen = ''
          if (EmpleadoConfiguracionEmpeladoRef.value.datos.imgInput) {
            const form = new FormData()
            form.append('file', EmpleadoConfiguracionEmpeladoRef.value.datos.imgInput, 'img.jpg')
            //SUBIR IMAGEN
            console.log('asq')

            await SeguridadService.subirImgEmpleado(form)
              .then(response => {
                console.log(response)
                imagen = response.data.img
              })
              .catch(error => {
                console.log(error)
              })
              .finally(() => {
                console.log('Termino')
              })
          }
          //CREAR O MODIFICAR
          await SeguridadService.modificarEmpleado({
            ...EmpleadoConfiguracionEmpeladoRef.value.datos,
            usuario: { ...EmpleadoConfiguracionSeguridadRef.value.datos.usuario },
            img: imagen == '' ? EmpleadoConfiguracionEmpeladoRef.value.datos.img : imagen,
          })
            .then(response => {
              console.log(response)

              ResetFormulario()
              context.emit('CargarListaEmpleados')
              store.commit('setAlert', {
                message: 'Guardado con exito',
                type: 'success',
              })
            })
            .catch(error => {
              console.log(error)
              store.commit('setAlert', {
                message: 'Disculpe se produjo un error al momento de guardar el empleado : ' + error,
                type: 'error',
              })
            })
            .finally(() => {
              console.log('Termino')
            })
        } else {
          tab.value = 0
          goTo(0)
          store.commit('setAlert', {
            message: 'Validar los datos del empleado',
            type: 'error',
          })
        }
      } else {
        store.commit('setAlert', {
          message: 'Ups error de modulo',
          type: 'error',
        })
      }
      console.log(datos)
    }

    const ResetFormulario = () => {
      tab.value = 0
      configuracionEmpleadoData.value = { ...configuracionEmpleadoDataInit }

      EmpleadoConfiguracionEmpeladoRef.value?.resetValidation()
      EmpleadoConfiguracionSeguridadRef.value?.resetValidation()
    }
    const configuracionEmpleadoDataInit = {
      empleado: {
        apellido: '',
        ci: '',
        direccion: '',
        id: -1,
        id_usuario: -1,
        img: '',
        modulo: '',
        nombre: '',
        telefono: '',
        tipo_empleado: '',
        usuario: {
          id: 0,
          usuario: '',
          clave: '',
          clave2: '',
          permisos_rol_general: [],
          permisos_rol_puestos: [],
          permisos_usuario_general: [],
          permisos_usuario_puesto: [],
        },
      },
      permisos: {
        bio: 'The name’s John Deo. I am a tireless seeker of knowledge, occasional purveyor of wisdom and also, coincidentally, a graphic designer. Algolia helps businesses across industries quickly create relevant 😎, scaLabel 😀, and lightning 😍 fast search and discovery experiences.',
        birthday: 'February 22, 1995',
        phone: '954-006-0844',
        website: 'https://themeselection.com/',
        country: 'USA',
        languages: ['English', 'Spanish'],
        gender: 'male',
      },
    }
    // account settings data
    const configuracionEmpleadoData = ref(configuracionEmpleadoDataInit)

    return {
      tab,
      tabs,
      configuracionEmpleadoData,
      icons: {
        mdiAccountOutline,
        mdiLockOpenOutline,
        mdiInformationOutline,
      },
      EnviarDatos,
      GuardarDatos,
      EmpleadoConfiguracionEmpeladoRef,
      EmpleadoConfiguracionSeguridadRef,
      CambiarTab, 
      ResetFormulario,
    }
  },
}
</script>
